import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import PageHeader from "../components/common/PageHeader";
import RatingSummary from "../components/testimonials/RatingSummary";
import TestimonialsGrid from "../components/testimonials/TestimonialsGrid";

const Testimonials = () => {
  usePageTitle(
    "Client Testimonials",
    "Read feedback from clients about NAF Construction's residential, commercial, renovation, and project delivery work in Ethiopia."
  );

  return (
    <div>
      <PageHeader
        title="Client Testimonials"
        subtitle="Hear directly from the clients we've built for."
      />
      <RatingSummary />
      <TestimonialsGrid />
   
    </div>
  );
};

export default Testimonials;